import React, { useState } from "react";
import Page from "../../organisms/Page";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import { Row, Col, Card, Form, Button, Spinner } from "react-bootstrap";
import DownloadIcon from "@mui/icons-material/Download";
import styled from "styled-components";
import {
  PlanActivoGuarderia,
  useDescargarPlanesActivos,
  useObtenerPlanesActivos,
} from "../../../services/analisisOperaciones";
import LoadingScreen from "../../organisms/LoadingScreen";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { downloadBlob } from "../../../utils/downloadUtils";
import { hoy } from "../../../utils/dateUtils";
import PlanesActivosTable from "./PlanesActivosTable";

const breadCrumbs: BreadCrumbItem[] = [
  { path: "/", label: "Inicio" },
  { path: "/analisis", label: "Análisis" },
  { path: "/analisis/operaciones", label: "Operaciones" },
  {
    path: "/analisis/operaciones/planes-activos",
    label: "Planes activos",
    isActive: true,
  },
];

function PlanesActivos() {
  const fechaCorte = hoy();
  const [itemsPorPagina, setItemsPorPagina] = useState(10);

  const { data, isLoading, error } = useObtenerPlanesActivos(fechaCorte);
  const descargaPlanesActivosMutacion = useDescargarPlanesActivos();

  const planesActivos: PlanActivoGuarderia[] = data || [];

  const descargarExcel = async () => {
    const respuesta = await descargaPlanesActivosMutacion.mutateAsync({
      fechaCorte,
    });
    const nombreArchivo = respuesta.nombre
      ? `${respuesta.nombre}${respuesta.extension ? `.${respuesta.extension}` : ""}`
      : `planes_activos_${fechaCorte}.xlsx`;
    downloadBlob(respuesta.contenido, nombreArchivo);
  };

  if (error) {
    return <ServerErrorModal />;
  }

  return (
    <Page
      title="Planes activos"
      description="Planes de guardería activos."
      breadCrumbs={breadCrumbs}
    >
      <LoadingScreen isLoading={isLoading} />
      <Row className="justify-content-center">
        <Col xs={12} md={12} lg={11} xxl={10}>
          <StyledCard>
            <Card.Body>
              <Row className="mb-3">
                <Col xs={12} md={4}>
                  <Form.Group controlId="itemsPorPagina">
                    <Form.Label>Items por página</Form.Label>
                    <Form.Select
                      value={itemsPorPagina}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                        setItemsPorPagina(parseInt(e.target.value))
                      }
                    >
                      {[5, 10, 15].map((pageSize) => (
                        <option key={pageSize} value={pageSize}>
                          {pageSize}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={8} className="d-flex align-items-end justify-content-md-end mt-3 mt-md-0">
                  <Button
                    variant="primary"
                    onClick={descargarExcel}
                    disabled={descargaPlanesActivosMutacion.isLoading}
                  >
                    {descargaPlanesActivosMutacion.isLoading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Descargando...
                      </>
                    ) : (
                      <>
                        <DownloadIcon sx={{ fontSize: 20, marginRight: "8px" }} />
                        Descargar
                      </>
                    )}
                  </Button>
                </Col>
              </Row>

              <PlanesActivosTable
                planesActivos={planesActivos}
                isLoading={isLoading}
                itemsPorPagina={itemsPorPagina}
              />
            </Card.Body>
          </StyledCard>
        </Col>
      </Row>
    </Page>
  );
}

const StyledCard = styled(Card)`
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export default PlanesActivos;
